import { render, staticRenderFns } from "./NewEnergy.vue?vue&type=template&id=133b9bb0&scoped=true"
import script from "./NewEnergy.vue?vue&type=script&lang=js"
export * from "./NewEnergy.vue?vue&type=script&lang=js"
import style0 from "./NewEnergy.vue?vue&type=style&index=0&id=133b9bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b9bb0",
  null
  
)

export default component.exports